import { ErrorMessage } from '@utils/error';
import { NotFound } from './NotFound';

export function ErrorDisplay(props: { info?: ErrorMessage }) {
  if (props.info?.message === 'Not found') return <NotFound>This project does not exist</NotFound>;

  if (props.info?.message === 'Not project admin')
    return <NotFound>You are not an admin for this project.</NotFound>;

  if (props.info?.message)
    return <NotFound>There was an error loading the page: {props.info.message}</NotFound>;

  if (props.info) {
    return (
      <NotFound>
        There was an error loading the page. Please refresh or contact support if the error
        persists.
      </NotFound>
    );
  }

  return null;
}
